import axios from 'axios';
import NewAccountFormConfiguration from '../models/NewAccountFormConfiguration';
import NewAccountFormConfigurationMapper from '../mappers/NewAccountFormConfigurationMapper';
import NewAccountFormEntry from '../models/NewAccountFormEntry';

export default class NewAccountFormService {
    public async getNewAccountFormConfiguration(formID: string): Promise<NewAccountFormConfiguration> {
        let api = axios.create({
            baseURL: ''
        })
        const data : any = await api.get('/NewAccount/NewAccountFormConfiguration?formID=' + formID);
        
        const configuration : NewAccountFormConfiguration = new NewAccountFormConfigurationMapper().map(data.data);
        
        return configuration;
    }

    public async getErrorMessageTranslations() : Promise<any> {
        let api = axios.create({
            baseURL: ''
        })
        const data : any = await api.get("/ResourceString/GetResourceStringsByFilter");

        return data.data;
    }

    public async sendNewAccountForm(values : NewAccountFormEntry){

        let api = axios.create({
            baseURL: ''
        })

        var bodyFormData = new FormData();

        for(let i = 0; i < values.files.length; i++){
            const file : File = values.files[i]
            bodyFormData.append("attachment" + i, file);
        }
        bodyFormData.append("firstname", values.firstname);
        bodyFormData.append("lastname", values.lastname);
        bodyFormData.append("email", values.email);
        
        bodyFormData.append("fileNumber", values.fileNumber);
        
        bodyFormData.append("consent", values.consent.toString());

        const data : any = await api.post('/NewAccount/SendNewAccountMail', bodyFormData);
    }
}